module.exports = __webpack_public_path__ + "static/media/placeholder.8249cee5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/products/placeholder.svg
// module id = 248
// module chunks = 37